/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import StyledTermsCondition from "./StyledTermsCondition";
import { Box } from "@mui/material";
import { fetchTermsAndCondition } from "../../../store/reducers/authentication/apiThunk";
import { useDispatch } from "react-redux";
import rollbar from "../../../rollbarConfig";

const TermsCondition = () => {

  const dispatch = useDispatch();
  const [htmlContent, setHtmlContent] = useState("");

  const getTermsAndCondition = async () => {
    const querry = "?section=seller"
    try {
      const res = await dispatch(fetchTermsAndCondition(querry));
      setHtmlContent(res?.payload?.data?.[0]?.document);
    } catch (error) {
      rollbar.error("Error message", error);
      console.log("Error fetching terms:", error);
    }
  };

  useEffect(() => {
    getTermsAndCondition();
  }, []);

  // Custom styles to apply to the HTML content
  const contentStyles = `
    .terms-content {
      font-family: 'Lexend', sans-serif;
      color: #333;
      line-height: 1.6;
    }
    .terms-content h1 {
      font-family: 'Lexend', sans-serif;
      font-size: 28px;
      font-weight: 500;
      margin-bottom: 20px;
      color: #000;
    }
    .terms-content h2 {
      font-family: 'Lexend', sans-serif;
      font-size: 24px;
      font-weight: 500;
      margin-top: 30px;
      margin-bottom: 15px;
      color: #000;
    }
    .terms-content h3 {
      font-family: 'Lexend', sans-serif;
      font-size: 20px;
      font-weight: 500;
      margin-top: 25px;
      margin-bottom: 10px;
      color: #000;
    }
    .terms-content p {
      font-family: 'Lexend', sans-serif;
      font-size: 16px;
      margin-bottom: 15px;
    }
    .terms-content ul, .terms-content ol {
      font-family: 'Lexend', sans-serif;
      margin-bottom: 15px;
    }
    .terms-content li {
      font-family: 'Lexend', sans-serif;
      margin-bottom: 8px;
    }
    .terms-content a {
      font-family: 'Lexend', sans-serif;
      color: #0066cc;
      text-decoration: underline;
    }
    .terms-content u, .terms-content strong {
      word-break: break-word;
    }
  `;
  const wrappedHtmlContent = `
    <style>${contentStyles}</style>
    <div class="terms-content">
      ${htmlContent}
    </div>
  `;
  return (
    <StyledTermsCondition>
       <Box className='terms-condition-wrap'>
        <Box dangerouslySetInnerHTML={{ __html: wrappedHtmlContent }} />
      </Box>
    </StyledTermsCondition>
  );
};

export default TermsCondition;